import http from "@utils/request";

/** 获取充值列表 */
export const getRelayControlRecord = (start_time,end_time,site_list,page=0,size=10) => http({
    method: "POST",
    url: "/phemsjava/getRelayControlRecord",
    data: {
        start_time,end_time,site_list,page,size
    },
});

/**
 * 充值
 * @param {*} siteno 
 * @param {*} price 
 * @param {*} total_price 
 * @returns 
 */
 export const relayControl=(siteno,operate,orderid,time)=>http({
    method:"POST",
    url:"/phemsjava/relayControl",
    data:{
        siteno,operate,orderid,time
    },
    // 不显示加载框
    unloading:false
})

/**
 * 查询设备是否在线
 * @param {*} siteno 
 * @returns 
 */
export const getRelayStatus=(siteno)=>http({
    method:"POST",
    url:"/phemsjava/getRelayStatus",
    data:{
        siteno
    },
    // 不显示加载框
    unloading:false
})

/**
 * 根据站点编号，获取设备的最新状态
 * @param {*} siteno 
 * @returns 
 */
export const updateRelayStatus=(siteno)=>http({
    method:"POST",
    url:"/phemsjava/updateRelayStatus",
    data:{
        siteno
    },
    // 不显示加载框
    unloading:false
})
